import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = {
  id: number;
};
export type VerifyVirtualKeyResponse = {};

export const useVerifyVirtualKey = createMutation<
  VerifyVirtualKeyResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/internal/partners/cars/${variables.id}/verify-virtual-key`,
      method: 'POST',
    }).catch((err: any) => {
      console.log('error', err);
      throw new Error(err.response.data.errors.join(', '));
    }),
});
